<template>
  <div class="search-log">
    <div class="el-search vue-top-padding radius">
      <div class="el-right">
        <el-form
          ref="searchForm"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item>
            <el-date-picker
              v-model="dateTime"
              :picker-options="pickerOptions"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              :start-placeholder="$t('searchProductProfit.start')"
              :end-placeholder="$t('searchProductProfit.end')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="type">
            <el-select
              v-model="search.type"
              :placeholder="$t('upgradeLog.type')"
              clearable
              @change="onSubmit"
            >
              <el-option :label="'APK'" :value="1"></el-option>
              <el-option :label="'VMC'" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mold">
            <el-select
              v-model="search.mold"
              :placeholder="$t('upgradeLog.mold')"
              clearable
              @change="onSubmit"
            >
              <el-option :label="$t('upgradeLog.moldMachine')" :value="1"></el-option>
              <el-option :label="$t('upgradeLog.moldManual')" :value="2"></el-option>
              <el-option :label="$t('upgradeLog.moldAuto')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="equipmentNo">
            <el-input
              v-model="search.equipmentNo"
              :placeholder="$t('upgradeLog.equipmentNo')"
              @input="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item prop="equipmentName">
            <el-input
              v-model="search.equipmentName"
              :placeholder="$t('upgradeLog.equipmentName')"
              @input="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
              $t("common.search")
            }}</el-button>
            <el-button @click="resetSearch('searchForm')" icon="el-icon-refresh">{{
              $t("common.reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchLog",
  props: {
    search: Object
  },
  data() {
    return {
      dateTime: "",
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("TimeControl.week"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("TimeControl.month"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("TimeControl.year"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    onSubmit() {
      if (this.dateTime && this.dateTime.length > 0) {
        this.search.startTime = this.dateTime[0];
        this.search.endTime = this.dateTime[1];
      } else {
        this.search.startTime = "";
        this.search.endTime = "";
      }
      this.$emit("onSubmit", this.search);
    },
    resetSearch(formName) {
      this.dateTime = null;
      this.$refs[formName].resetFields();
      this.$toolUtil.clearForm(this.search);
      this.$emit("resetSearch", this.search);
    }
  }
};
</script>

<style lang="scss" scoped></style>
